import { Link } from "react-router-dom";
import { m as motion } from "framer-motion";
import SafeImage from "./SafeImage";
import AmazonBuyButton from "./AmazonBuyButton";
import { isNovelNew } from "../lib/newBadge";

const statusLabel = {
  publie: "Publié",
  a_paraitre: "À paraître",
  en_preparation: "En préparation",
};

export default function BookCard({ novel, index = 0 }) {
  // Malo trilogy tomes use /romans/{slug}/tome-{N} canonical URL.
  const href =
    novel.trilogy_key === "malo" && novel.trilogy_tome
      ? `/romans/${novel.slug}/tome-${novel.trilogy_tome}`
      : `/romans/${novel.slug}`;
  const isNew = isNovelNew(novel.slug);
  return (
    <motion.article
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay: (index % 3) * 0.08, ease: [0.19, 1, 0.22, 1] }}
      data-testid={`book-card-${novel.slug}`}
      className="group"
    >
      <Link to={href} className="block">
        <div className="book-frame relative">
          {isNew && (
            <div
              className="absolute top-4 left-4 z-10 pointer-events-none bg-[var(--copper)] text-[var(--ivory)] px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.24em] shadow-md"
              data-testid={`book-card-${novel.slug}-new-badge`}
            >
              Nouveauté 2026
            </div>
          )}
          {novel.cover_url ? (
            <SafeImage src={novel.cover_url} alt={novel.title} />
          ) : novel.hero_image_url ? (
            <SafeImage src={novel.hero_image_url} alt={novel.title} />
          ) : (
            <div className="cover-placeholder">
              <div>
                <p className="eyebrow" style={{ color: "var(--gold-soft)" }}>Bruno Courtin</p>
              </div>
              <div>
                <h3 className="font-display text-3xl leading-tight">{novel.title}</h3>
                {novel.subtitle && (
                  <p className="font-display italic text-lg mt-2 opacity-90">{novel.subtitle}</p>
                )}
              </div>
              <div className="rule-copper" />
            </div>
          )}
          {novel.status === "a_paraitre" && novel.year && (
            <div className="absolute bottom-4 left-4 right-4 z-10 pointer-events-none">
              <div className="bg-[#c8221a] text-white text-center py-2 px-3 font-mono text-[11px] uppercase tracking-[0.18em] shadow-lg">
                Sortie prévue en {novel.year}
              </div>
            </div>
          )}
        </div>

        <div className="mt-5 flex items-start justify-between gap-4">
          <div>
            <p className="eyebrow" style={{ color: "var(--copper)" }}>
              {novel.genre || "Roman"}
            </p>
            <h3 className="font-display text-2xl md:text-3xl mt-2 text-[var(--ink)] leading-tight">
              {novel.title}
            </h3>
            {novel.subtitle && (
              <p className="font-display italic text-lg text-[var(--brown)] mt-1">{novel.subtitle}</p>
            )}
          </div>
          <span className="font-mono text-[10px] tracking-widest uppercase text-[var(--brown)]/70 whitespace-nowrap mt-1">
            {statusLabel[novel.status] || novel.status}
          </span>
        </div>

        {novel.short_description && (
          <p className="mt-3 text-[14px] leading-relaxed text-[var(--brown)]/80 max-w-md line-clamp-2">
            {novel.short_description}
          </p>
        )}

        <span className="mt-4 inline-flex items-center gap-2 text-[11px] font-mono uppercase tracking-widest text-[var(--ink)] group-hover:gap-4 transition-all duration-500">
          Découvrir
          <span aria-hidden>→</span>
        </span>
      </Link>
      {/* Amazon compact link (rendered outside Link to keep it clickable) */}
      <div className="mt-2">
        <AmazonBuyButton novel={novel} compact />
      </div>
    </motion.article>
  );
}
